import React from 'react';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import translate from './TranslateHOC';
import { cmsImageResize } from '../helpers';
import { Card } from '../v2/components/card/Card';
import LoadingError from '../components/alerts/LoadingError';

function ExtraFeeds({ strings, items, extraError, pathname }) {
  const showExtraFeed = (item) => {
    const isCatchUP = item.catch_up;
    const subtitle = isCatchUP
      ? strings.catchUp
      : item.hide_link
      ? item.hide_link_text
      : item.time_text;

    return (
      <Card
        image={cmsImageResize(item.image, '320x180')}
        isLive={!item.hide_link}
        onLater={item.hide_link}
        subtitle={subtitle}
        tag={strings.onlineExclusive}
        title={item.title}
        url={`/Live/${item.url}`}
        progress={'ads'}
        active={pathname === `/Live/${item.url}`}
        strings={strings}
        isOECatchUp={item.catch_up}
      />
    );
  };
  if (extraError) {
    return (
      <LoadingErrorContainer>
        <LoadingError errorMessage={strings.sorryLoading} />
      </LoadingErrorContainer>
    );
  }
  return (
    <>
      {Object.entries(items).length > 0 &&
        Object.entries(items).map(([key, item]) => (
          <div key={key}>{showExtraFeed(item)}</div>
        ))}
    </>
  );
}

const LoadingErrorContainer = styled.div`
  * {
    margin: 0;
  }
`;

const mapStateToProps = (state) => {
  return {
    curLang: state.curLang,
  };
};

export default translate(connect(mapStateToProps)(ExtraFeeds));
